import React, { useState, useEffect, useRef, useCallback } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button"; // TODO - use the Button from shred-component
import Icon from "@tw/style-guide/lib/components/icon/icon";
import { SearchModal } from "../searchModal/searchModal";
import styles from "./header.scss";
import "./header.css";
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import RecommendedProducts from "@tw/shared-ui-components/lib/components/recommendedProducts/recommendedProducts.jsx";
import { NotFoundIcon } from "../../assets/icons/notFoundIcon";
import _ from 'lodash';
import {
  getPdmApiUrl,
  getRouter,
  getUserLandingPage,
  tryBase64Decode,
  checkContainsString,
  hasUTMParams
} from "@tw/shared-ui-components/lib/utils/helper";
import CIMenuPanel from "../profileMenu/profilePanel";
import Navigation from "../navigation/navigation";
import NavigationMobile from "../navigation/navigationMobile";

import Cookies from "universal-cookie";
import CloseIcon from "../../assets/icons/close.png";
import {
  SearchIconGray,
  DropDownIcon,
  AmwayMobileIcon,
} from "../../assets/icons/icons";
import {
  useParamas,
  handleCancelBtn,
  getVisitorStatus,
} from "../../utils/helper";
import { ac_enums, fetchAcState } from "../../redux/reducers/index";
import { useSelector, useDispatch } from "react-redux";
import { getHotTopics } from "../search/utils";
//import debounce from "lodash/debounce";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";
import Spinner from "../spinner/spinner";
import { fetchCartCount } from "../../redux/reducers/index";
import SwitchRecipient from "@tw/shared-ui-components/lib/components/switchRecipient/switchRecipient";
import PopupConfirm from "@tw/shared-ui-components/lib/components/popupConfirm/popupConfirm";
import { getLoggedInUserInfo } from "../../utils/helper";
// import MobileSearchBar from "../mobileSearchBar/mobileSearchBar";
import MiniCart from "../miniCart/miniCart";
import { getCurrentPath, getQueryUTMString, getUrlAllParameter } from '@tw/shared-ui-components/lib/utils/helper';
import useVariantSelection from "@tw/shared-ui-components/lib/hooks/useVariantSelection";
import VariantDrawerMobile from "@tw/shared-ui-components/lib/components/variantDrawerMobile/variantDrawerMobile";
import VariantDetails from "@tw/shared-ui-components/lib/components/variantDetails/variantDetails";
import VariantDrawerDesktop from "@tw/shared-ui-components/lib/components/variantDrawerDesktop/variantDrawerDesktop";
import ProductActions from "../common/productActions/productActions";
import { StatusPopup } from "@tw/shared-ui-components/lib/components/statusPopup/statusPopup";
import { renderDeliveryInfo } from "../../utils/helper";
import useAddToCart from "../common/hooks/useAddToCart";
import { SEARCH_TYPES } from "../../utils/constants";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const Header = (props) => {
  // component variables
  const navHeight = useRef();
  const { headerData, breakpoint, Link } = props;
  const { cartItemCount } = headerData || {};
  let isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const listsRef = {};
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [navDomHeight, setNavDomHeight] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const [helpMenuAnchorEl, setHelpMenuAnchorEl] = useState(null);
  const [signInAnchorEl, setsignInAnchorEl] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [navBarTabEl, setNavBarTabEl] = useState(null);
  const [isShopBrandsOpen, setShopBrandsMenu] = useState(false);
  const [isShopProductsOpen, setShopProductsMenu] = useState(false);
  const [activeHB, openHamburger] = useState(false);
  const [openTab, setOpenTab] = useState(null);
  const [searchTab, openSearchTab] = useState(0);
  const [hotTopics, setHotTopics] = useState([]);
  const [placeHolderData, setPlaceHolderData] = useState("");
  const [histories, setHistory] = useState([]);
  const [showNoResultTemp, setShowNoResultTemp] = useState(false);
  const [crossIconStyles, setCrossIconStyles] = useState({ display: "none" });

  const [text, setText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isDropdownHidden, setIsDropdownHidden] = useState(true);
  const [notFoundText, setNotFoundText] = useState("");
  const [foundElementSkuCode, setFoundElementSkuCode] = useState(Number);
  const [showLogout, setShowLogout] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [actualSuggestionCount, setActualSuggestionCount] = useState(0);
  const JUMP_TO_HOME_PAGES_APIS = [
    /\/removeCartLanding/
  ]
  const {
    showModal: showStatusModal,
    setShowModal: setShowStatusModal,
    details,
    addToCartStatus,
  } = useAddToCart();

  const [openVariantDrawer, setOpenVariantDrawer] = useState(false);
  const [selectedVariantCode, setSelectedVariantCode] = useState(null);
  const [, /*selectedParentVariantCode*/ setSelectedParentVariantCode] =
    useState(null);
  const [productDetails, setProductDetails] = useState(null);

  const router = getRouter();
  const currPath = getCurrentPath()?.includes("?") ? getCurrentPath()?.split('?')[0] : getCurrentPath();
  const onVariantSelect = (itemCode, nonStrictVariants) => {
    selectedVariantCode != itemCode && setSelectedVariantCode(itemCode);
    if (Object.keys(nonStrictVariants || {})?.length) {
      const newParams = { frequency: nonStrictVariants["delivery_frequency"] };
      const queryParams = new URLSearchParams(newParams).toString();
      const currentPath = router.asPath?.split("?")[0] || "";
      router.push(`${currentPath}?${queryParams}`);
    }
  };

  const addToCart = async (product) => {
    if (product && product.isParentSku) {
      setOpenVariantDrawer(true);
      setSelectedParentVariantCode(product.itemCode);
      setSelectedVariantCode(product.itemCode);
      return;
    }

    await addToCartStatus(product);
  };

  const {
    selectVariant,
    selectedVariant,
    isValidVariant,
    isSelectedValue,
    getSelectedVariantValue,
  } = useVariantSelection(
    productDetails && productDetails.variants,
    productDetails && productDetails.skuList,
    productDetails && productDetails.validVariants,
    onVariantSelect,
    selectedVariantCode
  );

  useEffect(() => {
    if (!selectedVariantCode) return;
    setProductDetails(null);
    const getVariantDetails = async () => {
      try {
        const apiUrl = getPdmApiUrl();
        const res = await axios.post(
          `/products/${selectedVariantCode}`,
          {},
          {
            baseURL: apiUrl,
          }
        );
        setProductDetails(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    getVariantDetails();
  }, [selectedVariantCode]);

  const renderVariants = () => (
    <>
      {productDetails &&
        productDetails.variants &&
        productDetails.variants.map((variant, variantIndex) => (
          <VariantDetails
            variant={variant}
            variantIndex={variantIndex}
            selectedVariant={selectedVariant}
            selectVariant={selectVariant}
            isValidVariant={isValidVariant}
            isSelectedValue={isSelectedValue}
            getSelectedVariantValue={getSelectedVariantValue}
            key={variantIndex}
          />
        ))}
    </>
  );

  const renderDrawerFooter = () => (
    <ProductActions
      productInfo={productDetails.info}
      onSuccess={() => setOpenVariantDrawer(false)}
      productStatusObj={details.productStatus}
    />
  );

  const loggedInUserData = getLoggedInUserInfo();
  const isvisitor = getVisitorStatus();
  useEffect(() => {
    if (
      (loggedInUserData &&
        loggedInUserData.accessToken &&
        loggedInUserData.loginAda &&
        loggedInUserData.role) ||
      (isvisitor && loggedInUserData?.vAda)
    ) {
      dispatch(fetchCartCount());
    }
  }, []);

  const viewCount = (count) => {
    if (Number(count) > 99) {
      return "99+";
    } else {
      return count;
    }
  };

  //hot topics component

  const HotTopics = () => {
    return (
      <div className={styles["hot_topics_container"]}>
        {hotTopics && hotTopics.length ? (
          <div className={styles["hot_topics_text"]}>熱門搜尋</div>
        ) : null}

        <div className={styles["hot_topics"]}>
          {hotTopics?.length > 0 &&
            hotTopics
              .slice(0, 8)
              .filter(Boolean)
              .map((value, valueIndex) => {
                return (
                  <label key={valueIndex} className={styles["labl"]}>
                    <input
                      type="radio"
                      value={value}
                      autoComplete="off"
                      name="hot_topics_radio_btns"
                      onChange={async () => {
                        setText(value);
                        if (await ifSearchResultFound(value)) {
                          router.push(
                            `/search/${value}?type=${SEARCH_TYPES.SUGGESTED}${getQueryUTMString('&')}`
                          );
                          onCloseSearchTab();
                        } else {
                          setShowNoResultTemp(true);
                          setNotFoundText(value);
                        }
                      }}
                    />
                    <div className={styles.hot_topic_btn}>
                      <span className={styles["hot_topic_btn_text"]}>
                        {value}
                      </span>
                    </div>
                  </label>
                );
              })}
        </div>
        <div className={styles["space_div"]}></div>
      </div>
    );
  };

  const SuggestionNotFoundContent = () => {
    return (
      <div className={styles["hot_topics_div"]}>
        <div className={styles["suggesion_not_found_text"]}>
          未搜尋到相關商品 | 建議您熱門搜尋關鍵字如下
        </div>

        <div className={styles["hot_topics"]}>
          {hotTopics &&
            hotTopics.map((value, valueIndex) => {
              return (
                <label key={valueIndex} className={styles["labl"]}>
                  <input
                    type="radio"
                    value={value}
                    name="hot_topics_radio_btns"
                    autoComplete="off"
                    onChange={async () => {
                      setText(value);
                      if (await ifSearchResultFound(value)) {
                        router.push(`/search/${value}${getQueryUTMString('?')}`);
                        onCloseSearchTab();
                      } else {
                        setShowNoResultTemp(true);
                        setNotFoundText(value);
                      }
                    }}
                  />
                  <div className={styles.hot_topic_btn}>
                    <span className={styles["hot_topic_btn_text"]}>
                      {value}
                    </span>
                  </div>
                </label>
              );
            })}
        </div>

        <div className={styles["space_div_0"]}></div>
      </div>
    );
  };

  // search onClick Handler

  function getStorageValue(key, defaultValue) {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem(key);
      const initial = saved !== null ? JSON.parse(saved) : defaultValue;
      return initial;
    }
  }

  const onEnteringSearch = () => {
    if (localStorage.getItem("AmwTwRecentSearches") == null) {
      localStorage.setItem("AmwTwRecentSearches", JSON.stringify([]));
    } else {
      setHistory(getStorageValue("AmwTwRecentSearches", []));
    }
  };

  const onCloseSearchTab = () => {
    openSearchTab(!searchTab);
    document.getElementById("header_sm").style.filter = "none";
    onEnteringSearch();
  };

  const onCloseSearch = () => {
    //setText("");
    // if (typeof window !== undefined)
    //   document.getElementById("inputSearch").value = "";
    setText("");
    setSuggestions([]);
    setIsDropdownHidden(true);
    setShowNoResultTemp(false);
    openSearchTab(false);
    document.getElementById("header_sm").style.filter =
      "drop-shadow(0px 2px 4px rgba(44, 44, 44, 0.12))";
  };

  // component functions
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const toggleLanguageDropdown = (event) => {
    setLanguageAnchorEl(event.currentTarget);
  };
  const toggleHelpMenuDropdown = (event) => {
    setHelpMenuAnchorEl(event.currentTarget);
  };
  // TEP-16718 从定向首页
  const isJumpToHomePage = (url) => JUMP_TO_HOME_PAGES_APIS.some((route) => url.match(route));

  const isLocationPathname = () => {
    return location.hash.includes("?") ?
      isJumpToHomePage(location.hash.split('?')[0].substring(1)) ? "/" : location.hash.split('?')[0].substring(1) :
      isJumpToHomePage(location.hash.substring(1)) ? "/" : location.hash.substring(1)
  }

  const toggleSignInDropdown = (event) => {
    if (typeof window !== "undefined") {
      const cookie = new Cookies();
      const curAda = cookie.get("ada");
      const shareADA = sessionStorage.getItem("shareADA");
      if (!curAda) {
        if (breakpoint === "xs" || breakpoint === "sm") {
          // mobile
          showProfileMobileMenuLink(true);
        } else {
          if (location.pathname) {
            const parameter = getUrlAllParameter();
            //  區分 Hash 模式
            let pathname = location.host == 'localhost:8080'
              ?
              isLocationPathname()
              :
              isJumpToHomePage(location.pathname) ? '/' : location.pathname
            if (shareADA) {
              let params = `${pathname}?shareADA=${shareADA}${parameter !== "" ? `&${parameter}` : ""}`
              router.push(`/login?h=${btoa(params)}`);
            } else {
              let params = `${pathname}${parameter !== "" ? `?${parameter}` : ""}`
              router.push(`/login?h=${btoa(params)}`);
            }
          } else router.push("/login")
        }
      } else {
        if (breakpoint === "xs" || breakpoint === "sm") {
          showProfileMobileMenuLink(true);
        } else {
          let targetPath = `${getUserLandingPage()}${getUserLandingPage().includes("?") ? getQueryUTMString("&") : getQueryUTMString("?")}`
          router.push(targetPath);
        }
      }
    }
  };
  const showProfileMobileMenuLink = (status) => {
    setShowProfileMenu(status);
  };

  const handleClose = () => {
    setLanguageAnchorEl(null);
    setHelpMenuAnchorEl(null);
    setsignInAnchorEl(null);
  };
  const hamburgerClickHandler = () => {
    openHamburger(false);
  };
  const openShopBrands = (e) => {
    e.stopPropagation();
    setShopBrandsMenu(!isShopBrandsOpen);
  };
  const openShopProducts = (e) => {
    e.stopPropagation();
    setShopProductsMenu(!isShopProductsOpen);
  };
  const openNavBarTab = (index) => {
    const ref = listsRef[index];
    setNavBarTabEl(ref);
    setOpenTab(index);
  };
  const closeNavBarTab = () => {
    setNavBarTabEl(null);
  };
  const setListsRef = (index, node) => {
    listsRef[index] = node;
  };

  const onCartClick = () => {
    try {
      if (!router?.asPath) return;
      const asPath = router?.asPath;
      const conditionalEnumeration = hasUTMParams(asPath)
      /**
       * 當用戶在登錄頁面點擊購物車按鈕時。
       * 此時需要判斷當前路徑參數是否轉碼。
       * 如果路徑轉碼，需要主動解碼。
       * 避免影響 UTM 參數在路徑跳轉中丟失
       * */
      if (asPath.indexOf("h=") !== -1 && !conditionalEnumeration) {
        if (!asPath.includes("?")) return ''
        let arr = asPath.split('?')
        let query = arr[1];
        //  判断一个字符串是否需要使用 atob 解码
        if (tryBase64Decode(query.split("=")[1])) {
          let parameter = atob(query.split("=")[1])
          if (router) router.push(`/cart?p=${parameter.replace(/[?]+/g, '&')}`);
        } else {
          if (checkContainsString(query)) {
            // 检查参数中是否有 p= 相关参数
            if (router) router.push(`/cart?p=${query.split('p=')[1]}`);
          } else if (query.indexOf("h=") != -1) {
            // 检查参数中是否有 h= 相关参数
            if (router) router.push(`/cart?p=${query.split('h=')[1]}`);
          } else {
            //  直接设置首页为上一页
            if (router) router.push(`/cart?p=/`);
          }
        }
      } else {
        let arr = asPath.split('?')
        let query = arr[0];
        if (
          asPath.indexOf("COMBINATION_MASTER_ITEM_CODE") != -1 &&
          asPath.indexOf("COMBINATION_MASTER_QUANTITY") != -1 &&
          asPath.indexOf("COMBINATION_QUANTITIES") != -1 &&
          asPath.indexOf("COMBINATION_CONSIGNEE_ADA") != -1
        ) {
          if (router) router.push(`/cart?p=${query}`);
        } else {
          if (query == '/login') {
            if (router) router.push(arr[1] ? `/cart?${arr[1]}` : `/cart`);
          } else {
            if (router) router.push(`/cart?p=${asPath.replace(/[?]+/g, '&')}`);
          }
        }
      }
    } catch (error) {
      console.log('onCartClick >> catch:', error);
    }
  };

  const categories = [
    "最新促銷",
    "暢銷",
    "健康與營養",
    "健康與護膚",
    "家居科技",
    "個人護理",
    "家庭清潔",
    "更多產品",
    "SOP",
    "3E",
    "我的優惠券",
    "我的捆綁",
    "我最喜歡的",
  ];

  const openModal = async (e) => {
    if (e) e.stopPropagation();
    setShowModal(true);
    onEnteringSearch();
  };

  const closeModal = () => {
    setShowModal(false);
  };
  //added changes

  const clearSearchHandler = (item) => () => {
    setHistory(histories.filter((val) => item != val));
    localStorage.setItem(
      "AmwTwRecentSearches",
      JSON.stringify(histories.filter((val) => item != val))
    );
  };

  const removeAllHandler = () => {
    setHistory([]);
    localStorage.setItem("AmwTwRecentSearches", JSON.stringify([]));
  };

  const onSuggestHandler = (text, skuCode) => {
    router.push(`/products/${skuCode}`);
    updateLocalStorage();
    onCloseSearchTab();
    setSuggestions([]);
    setIsDropdownHidden(true);
    // if (typeof window !== undefined)
    //   document.getElementById("inputSearch").value = "";
    setText("");
  };

  const onChangeHandler = (text) => {
    setShowNoResultTemp(false);
    //setText(text);
    if (text.length === 0) {
      setSuggestions([]);
      setIsDropdownHidden(true);
      return;
    }

    if (!isNaN(text) && text.length < 3) {
      setSuggestions([]);
      return;
    }

    if (text.length > 0) {
      setSuggestions([]);
      const searchSuggestions = async (text) => {
        try {
          setLoading(true);
          const apiUrl = getPdmApiUrl();
          const res = await axios.post(
            `/search/searchSuggestions`,
            {
              keyword: text,
              // defaultSku: false,
            },
            {
              baseURL: apiUrl,
            }
          );
          if (res.data.data) {
            let suggestionList = [];
            let suggestionLength = res.data.data.searchInfo.length;
            setActualSuggestionCount(res?.data?.data?.count);
            suggestionLength = suggestionLength < 5 ? suggestionLength : 5;

            for (
              let suggestionIndex = 0;
              suggestionIndex < suggestionLength;
              suggestionIndex++
            ) {
              suggestionList[suggestionIndex] =
                res.data.data.searchInfo[suggestionIndex];
            }

            setSuggestions(suggestionList);
            setIsDropdownHidden(false);
          }
          setLoading(false);
        } catch (err) {
          console.log(err);
          setLoading(false);
        }
      };
      searchSuggestions(text);
    }
    // setText(text);
    // setSuggestions([]);
    setIsDropdownHidden(true);
    // if (typeof window !== undefined) {
    //   console.log(text);

    //   document.getElementById("inputSearch").value = text;
    //   document.getElementById("inputSearchDesktop").value = text;
    // }
    setText(text);
  };

  const splitSuggestion = (searchText) =>
    searchText &&
    searchText.split(new RegExp(`(${text})`, `gi`)).map((subPart, i) => {
      return (
        <span
          style={{
            color:
              subPart.toLowerCase() === text.toLocaleLowerCase()
                ? "#38539a"
                : "black",
          }}
        >
          {subPart}
        </span>
      );
    });

  const placeHolder = async () => {
    try {
      const apiUrl = getPdmApiUrl();
      axios
        .post(
          `/search/retrieveDefaultKeyword`,
          {},
          {
            baseURL: apiUrl,
          }
        )
        .then((res) => {
          setPlaceHolderData(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const selectRecentSearch = (item) => () => {
    setText(item);
    onChangeHandler(item);
  };

  const Recentlysearched = (text) => {
    return (
      histories &&
      histories.some(function (item) {
        return item == text;
      })
    );
  };

  const updateLocalStorage = () => {
    let newHistories = [];
    newHistories = histories || [];
    const capitalizeText = text.charAt(0)?.toUpperCase() + text.slice(1);

    if (!capitalizeText) return;

    if (Recentlysearched(capitalizeText)) {
      return;
    }
    newHistories = newHistories.reverse();
    if (histories.length < 5) {
      newHistories.push(capitalizeText);
    } else if (histories.length === 5) {
      newHistories = histories.slice(1);
      newHistories.push(capitalizeText);
    }

    newHistories = newHistories.reverse();
    setHistory(newHistories);

    localStorage.setItem("AmwTwRecentSearches", JSON.stringify(newHistories));
  };

  //debounce function

  const debounce = (fn, delay) => {
    let timeOutId;
    return function (...args) {
      if (timeOutId) clearTimeout(timeOutId);

      timeOutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const ifSearchResultFound = async (keyword) => {
    let param;
    if (loggedInUserData.role !== "Guest") {
      param = {
        keyword,
        // defaultSku: false,
        role: loggedInUserData.role,
      };
    } else {
      param = {
        keyword,
        // defaultSku: false,
      };
    }
    try {
      const apiUrl = getPdmApiUrl();
      const res = await axios.post(
        `/plp/list`,
        {
          ...param,
        },
        {
          baseURL: apiUrl,
        }
      );
      return !!(res.data && res.data.totalElements);
    } catch (error) {
      toastMsg("Please try again later !");
      console.log(error.message);
    }
  };

  const onSearch = async (e) => {
    e.preventDefault();
    updateLocalStorage();

    setSuggestions([]);
    setIsDropdownHidden(true);

    const selectedText = encodeURIComponent(text);

    // setText("");
    // if (typeof window !== undefined) {
    //   document.getElementById("inputSearch").value = "";
    //   document.getElementById("inputSearchDesktop").value = "";
    // }
    //setText("");
    if (breakpoint === "sm" || breakpoint === "xs") {
      if (await ifSearchResultFound(decodeURIComponent(selectedText))) {
        if (location.pathname.includes("/search/")) {
          router.replace(`/search/${selectedText}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
        } else {
          router.push(`/search/${selectedText}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
        }
        onCloseSearch();
      } else {
        setShowNoResultTemp(true);
        setNotFoundText(selectedText);
      }
    } else {
      if (location.pathname.includes("/search/")) {
        router.replace(`/search/${selectedText}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
      } else {
        router.push(`/search/${selectedText}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
      }
      closeModal();
    }
    // setText("");
    // if (typeof window !== undefined) {
    //   document.getElementById("inputSearch").value = "";
    //   document.getElementById("inputSearchDesktop").value = "";
    // }
    //setText("");
  };

  const delayedQuery = useCallback(
    debounce((q) => onChangeHandler(q), 800),
    []
  );
  // const onChange = (e) => {
  //   delayedQuery(e.target.value);
  // };

  useEffect(async () => {
    placeHolder();
    const hotTopics = await getHotTopics();
    setHotTopics(hotTopics);
  }, []);

  //changes ended
  let profileName = "登入";
  let username = "";
  let mainName = "";
  if (typeof window !== "undefined") {
    const cookie = new Cookies();
    const users = cookie.get("user");
    const role = cookie.get("role");
    mainName = cookie.get("mainName");
    let curUser = {};
    if (users && users.length) {
      users.map((u) => {
        //if (u.isMaster)
        curUser = u;
      });
    }

    if (curUser.name) {
      if (curUser.name?.trim() === "") {
        profileName = "您好";
      } else {
        profileName = curUser.name;
      }
      username = curUser.name;
    } else {
      profileName = "請登入";
      username = "";
      sessionStorage.removeItem('REMINDED_ITEM_CODE_ARR')
    }
  }
  const headerMobileRef = useRef();

  //Nagivation

  const userState = useSelector((state) => state.userState || {});
  const [navigationMenus, setNavigationMenus] = useState([]);
  const [footerFromCS, setFooterFromCS] = useState([]);
  let navTabs = [];
  if (typeof window !== "undefined" && localStorage.getItem("nav")) {
    let nav = JSON.parse(localStorage.getItem("nav"));
    navTabs = nav
      .filter((item) => item.subCategories.length > 0)
      .map((item) => ({
        code: item.code,
        name: item.name,
      }));
  }

  useEffect(() => {
    if (
      !userState.navigation ||
      !userState.navigation.data ||
      !userState.navigation.data.category
    )
      return;
    setNavigationMenus(
      userState.navigation.data.category.filter(
        (item) => item.subCategories.length > 0
      )
    );

    navTabs = userState.navigation.data.category
      .filter((item) => item.subCategories.length > 0)
      .map((item) => ({
        code: item.code,
        name: item.name,
      }));

    setFooterFromCS(userState.navigation.data.cs || []);
    localStorage.setItem(
      "nav",
      JSON.stringify(
        userState.navigation.data.category.filter(
          (item) => item.subCategories.length > 0
        )
      )
    );
    localStorage.setItem(
      "navFooter",
      JSON.stringify(userState.navigation.data.cs || [])
    );
  }, [userState]);

  const [selectedNav, setSelectedNav] = useState("");
  const handleSelectNavigation = (value) => {
    setSelectedNav(value);
  };

  // const tabsDesktop = [
  //   { name: "店鋪產品", code: "product" },
  //   { name: "店鋪品牌", code: "brand" },
  //   { name: "程序/發現", code: "discover" },
  // ];

  let nav = "";
  let navFooter = "";

  if (typeof window !== "undefined") {
    nav = localStorage.getItem("nav");
    navFooter = localStorage.getItem("navFooter");
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      // if (navigationMenus.length > 0 && !localStorage.getItem('nav')) {
      //   // check from state
      //   localStorage.setItem("nav", JSON.stringify(navigationMenus));
      //   // dispatch(setNavigationState({}))
      // }

      // if (footerFromCS.length > 0 && !localStorage.getItem('navFooter')) {
      //   // check from state
      //   localStorage.setItem("navFooter", JSON.stringify(footerFromCS));
      //   // dispatch(setNavigationState({}))
      // }

      let navMenu = JSON.parse(localStorage.getItem("nav") || "[]");
      let navFooterMenu = JSON.parse(localStorage.getItem("navFooter") || "[]");
      if (navigationMenus.length === 0 && localStorage.getItem("nav")) {
        setNavigationMenus(navMenu);
      }

      if (footerFromCS.length === 0 && localStorage.getItem("navFooter")) {
        setFooterFromCS(navFooterMenu);
      }

      if (
        (navigationMenus.length === 0 && !localStorage.getItem("nav")) ||
        (footerFromCS.length === 0 && !localStorage.getItem("navFooter"))
      ) {
        dispatch(fetchAcState(ac_enums.SET_NAVIGATION_STATE));
      }

      // if (navigationMenus.length === 0 || footerFromCS.length === 0) {
      //   // get from backend, if not found from state
      //   let navMenu = JSON.parse(localStorage.getItem("nav") || "[]");
      //   let navFooterMenu = JSON.parse(localStorage.getItem("navFooter") || "[]");

      //   if (navMenu.length === 0 || navFooterMenu.length === 0) {
      //     dispatch(fetchNavigationState());
      //   }
      // }
    }
  }, [nav, navFooter]);

  // //Nagivation  Mobile

  const [selectedType, setSelectedType] = useState("product");
  const switchTab = (event, type) => {
    setSelectedType(type);
  };

  // const tabs = [
  //   { name: "選購產品", code: "product" },
  //   { name: "商店品牌", code: "brand" },
  //   { name: "計劃/發現", code: "discover" },
  // ];

  //Nagivation Ended

  // Login Out
  const handleActionLogout = () => {
    setShowLogout(false);
    router.push("/logout");
  };

  const params = useParamas();
  const keyword =
    params && params.params && params.params.keyword
      ? params.params.keyword
      : "";

  useEffect(() => {
    setText(decodeURIComponent(keyword));
  }, [keyword]);

  const handleActionCancel = () => {
    setShowLogout(false);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    setShowLogout(true);
  };
  // Login Out end
  const headerDesktopRef = useRef();
  const desktopSearchRef = useRef();

  // const [scrollY, setScrollY] = useState(false);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    setShowShadow(false);
  }, [router?.location?.pathname]);

  useEffect(() => {
    let timeOutId;
    const scroll = () => {
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      if (winScroll > 64) {
        setShowShadow(true);
      } else {
        if (winScroll < 1) setShowShadow(false);
      }
    };

    if (showShadow) {
      timeOutId = setTimeout(
        () => window.addEventListener("scroll", scroll),
        500
      );
    } else window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
      clearTimeout(timeOutId);
    };
  });

  const headId =
    typeof window !== "undefined"
      ? document.getElementById("searchboxRef")
      : null;

  const observer = useRef(
    typeof window !== "undefined" && typeof IntersectionObserver !== "undefined"
      ? new IntersectionObserver(
        (entries) => {
          console.log('entries', entries)
          const first = entries[0];
          if (first?.isIntersecting) {
            setShowSearchBar(true);
          } else {
            setShowSearchBar(false);
          }
        },
        { rootMargin: "-20px 0px 0px 0px" }
      )
      : null
  );

  useEffect(() => {
    location?.pathname != "/" ? setShowSearchBar(false) : null;

    const currentElement = headId;
    const currentObserver = observer?.current;
    if (currentElement) {
      currentObserver?.observe(currentElement);
    }
    return () => {
      if (currentElement) {
        currentObserver?.unobserve(currentElement);
      }
    };
  }, [headId]);

  useEffect(() => {
    if (isDesktop) {
      setNavDomHeight(navHeight.current.clientHeight + 50); //獲取元素高度 加上 50像素安全距離
    }
  }, [isDesktop, username]);

  const ControllScroll = () => {
    document.body.style.overflow = document.documentElement.style.overflow = 'hidden'
  }
  // ----------------------code starts for cross icon in input field-------------------------------

  let input_search;
  if (typeof window !== "undefined") {
    if (breakpoint === "sm" || breakpoint === "xs") {
      input_search = document.getElementById("inputSearch");
    } else {
      input_search = document.getElementById("inputSearchDesktop");
    }
  }

  const onChangeOfSearchInput = (text) => {
    setText(text);
    delayedQuery(text);
  };

  const onCrossIconClick = (e) => {
    e.stopPropagation();
    input_search.focus();
    onChangeOfSearchInput("");
  };
  useEffect(() => {
    handleCancelBtn(input_search, setCrossIconStyles);
  }, [text]);

  // let lgHeaderShadow = "drop-shadow(0px 3px 4px rgba(44, 44, 44, 0.12))";
  let lgHeaderShadow = "0px 15px 10px -15px #2c2c2c1e";



  const [scrollY, setScrollY] = useState(true)
  useEffect(() => {
    window.addEventListener('scroll', toggleBackToTop);
    sethomePagePath(getQueryUTMString('?') ? `/${getQueryUTMString('?')}` : `/`)
  });
  const throttleFunction = _.throttle(() => {
    const scrolled = document.documentElement.scrollTop
    setScrollY(scrolled < 100 ? true : false)
  }, 300);
  const toggleBackToTop = () => {
    throttleFunction();
  };


  const [homePagePath, sethomePagePath] = useState(null)

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', toggleBackToTop)
  }
  // ----------------------code ends for cross icon in input field-------------------------------
  return (
    <div className={`${styles.header_container} header-div`} ref={navHeight}>
      {/* {breakpoint == "xs" || breakpoint == "sm" ? ( */}
      <div
        id="header_sm"
        className={styles.header_sm}
        ref={headerMobileRef}
      //style={showSearchBar ? { paddingBottom: 65 } : undefined}
      >
        <div className={styles.top_bar}>
          <div className={styles.left_icons}>
            <div
              className={styles.hamburger_icon}
              onClick={() => openHamburger(true)}
            >
              <Icon name={"hamburger"} />
            </div>
            <div className={styles.logo_area}>
              <a href={homePagePath}>
                <AmwayMobileIcon />
              </a>
            </div>
          </div>
          <div className={styles.right_icons}>

            <div
              className={styles["small-search-icon"]}
              // onClick={() => {
              //   setShowSearchBar(true);
              //   setScrollY(true);
              // }}
              onClick={onCloseSearchTab}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.6083 17.2162L22.8761 21.484C23.0413 21.6492 23.0413 21.9164 22.8761 22.0816L22.0816 22.8761C21.9164 23.0413 21.6492 23.0413 21.484 22.8761L17.2162 18.6083C17.1389 18.5275 17.0932 18.422 17.0932 18.3095V17.8455C15.81 18.9528 14.1402 19.6243 12.3121 19.6243C8.27289 19.6243 5 16.3514 5 12.3121C5 8.27289 8.27289 5 12.3121 5C16.3514 5 19.6243 8.27289 19.6243 12.3121C19.6243 14.1402 18.9528 15.81 17.8455 17.0932H18.3095C18.422 17.0932 18.5275 17.1353 18.6083 17.2162ZM6.68742 12.3121C6.68742 15.4198 9.20448 17.9369 12.3121 17.9369C15.4198 17.9369 17.9369 15.4198 17.9369 12.3121C17.9369 9.20448 15.4198 6.68742 12.3121 6.68742C9.20448 6.68742 6.68742 9.20448 6.68742 12.3121Z"
                  fill="#2C2C2C"
                />
              </svg>
            </div>

            <div className={styles.user_icon} onClick={toggleSignInDropdown}>
              <Icon name={"user_icon"} />
            </div>
            <div className={styles.shopping_cart} onClick={onCartClick}>
              <Icon name={"shopping_cart"} />
              {cartItemCount === 0 ? null : (
                <div className={styles["cart_count_mobile"]}>
                  {viewCount(cartItemCount)}
                </div>
              )}
            </div>
            {/* 移动端商品菜单 */}
            <SwipeableDrawer
              anchor={"left"}
              open={activeHB}
              disableDiscovery={false}
              disableSwipeToOpen={true}
              onClose={() => openHamburger(false)}
              onOpen={() => console.log('Drawer is opening')}
            >
              <div className={styles.mobile_hamburger_view}>
                {username && loggedInUserData.role === "ABO" && (
                  <div className={styles.switchRecipient}>
                    <div className={styles.SwitchRecipient_box}>
                      <SwitchRecipient
                        variants="buyer"
                        breakpoint={breakpoint}
                        text="目前訂貨人"
                      />
                    </div>
                    <div
                      className={styles.hamburger_btn}
                      onClick={hamburgerClickHandler}
                    >
                      <img
                        className={styles.hamburger_close}
                        src={CloseIcon}
                        style={{
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                  </div>
                )}
                {navTabs?.length > 0 && (
                  <div
                    className={styles["tabs"]}
                    style={{
                      paddingTop:
                        username && loggedInUserData.role === "ABO"
                          ? "30px"
                          : "22px",
                    }}
                  >
                    <Tabs
                      value={selectedType}
                      onChange={switchTab}
                      className="Tabs_container"
                    >
                      {navTabs.map((tab, index) => {
                        return (
                          <Tab
                            label={tab.name}
                            value={tab.code}
                            key={`headerSelected${index}`}
                          />
                        );
                      })}
                    </Tabs>

                    {loggedInUserData.role !== "ABO" && (
                      <div
                        onClick={hamburgerClickHandler}
                        className={styles.hamburger_btn}
                      >
                        <img
                          className={styles.hamburger_close}
                          src={CloseIcon}
                          style={{
                            verticalAlign: "middle",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {navigationMenus.length > 0 &&
                  navigationMenus.filter((item) => item.type === selectedType)
                    .length > 0 && (
                    <NavigationMobile
                      Link={Link}
                      type={selectedType}
                      cs={footerFromCS}
                      hamburgerClickHandler={hamburgerClickHandler}
                      navigationMenus={
                        navigationMenus.filter(
                          (item) => item.type === selectedType
                        )[0].subCategories
                      }
                    />
                  )}
              </div>
            </SwipeableDrawer>

            {/* Search code starts */}
            <div
              className={`${styles.hamburger_view} ${searchTab === true ? styles.open_drawer : ""
                }`}
            >
              <div className={styles.search_tab}>
                <div className={styles.search_area1}>
                  <form
                    className={styles.form_control1}
                    onSubmit={onSearch}
                    autoComplete="off"
                    action=""
                  >
                    <div className={styles["search_input_holder"]}>
                      <input
                        type="search"
                        id="inputSearch"
                        autoComplete="off"
                        className={styles.form_input}
                        placeholder={placeHolderData ? placeHolderData : "搜索"}
                        value={text}
                        onFocus={() =>
                          handleCancelBtn(input_search, setCrossIconStyles)
                        }
                        onChange={(e) => onChangeOfSearchInput(e.target.value)}
                      />
                    </div>
                    <div className={styles.search_icon}>
                      <SearchIconGray />
                    </div>
                    {loading ? (
                      <div className={styles["show_indicator"]}>
                        <Spinner />
                      </div>
                    ) : null}
                    {/*<span
                      onClick={onCrossIconClick}
                      className={styles["cancel-btn"]}
                      style={crossIconStyles}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9561 9.97925L16.4305 5.5049C16.6892 5.24613 16.6892 4.82619 16.4305 4.567L15.3908 3.52733C15.132 3.26856 14.7121 3.26856 14.4529 3.52733L9.97896 8.0021L5.50461 3.52775C5.24584 3.26897 4.8259 3.26897 4.56671 3.52775L3.52746 4.567C3.26868 4.82578 3.26868 5.24571 3.52746 5.5049L8.00181 9.97925L3.52746 14.4536C3.26868 14.7124 3.26868 15.1323 3.52746 15.3915L4.56712 16.4312C4.8259 16.6899 5.24584 16.6899 5.50503 16.4312L9.97896 11.9564L14.4533 16.4308C14.7121 16.6895 15.132 16.6895 15.3912 16.4308L16.4309 15.3911C16.6897 15.1323 16.6897 14.7124 16.4309 14.4532L11.9561 9.97925Z"
                          fill="#2C2C2C"
                        />
                      </svg>
                    </span>*/}
                  </form>

                  {!showNoResultTemp && suggestions.length != 0 ? (
                    suggestions &&
                      ((!isNaN(text) && text.length > 2) || isNaN(text)) ? (
                      <>
                        <div className={styles["count"]}>
                          找到 {actualSuggestionCount} 個商品{" "}
                          <div className={styles["show_all_result"]} onClick={() => {
                            if (breakpoint === "sm" || breakpoint === "xs") {
                              if (ifSearchResultFound(decodeURIComponent(text))) {
                                if (location.pathname.includes("/search/")) {
                                  router.replace(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                                } else {
                                  router.push(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                                }
                                onCloseSearch();
                              } else {
                                setShowNoResultTemp(true);
                                setNotFoundText(text);
                              }
                            } else {
                              if (location.pathname.includes("/search/")) {
                                router.replace(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                              } else {
                                router.push(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                              }
                              closeModal();
                            }
                          }
                          }>顯示全部搜尋結果</div>
                        </div>

                        {suggestions.map((suggestion, i) => (
                          <div
                            className={styles["suggesion"]}
                            onClick={() =>
                              onSuggestHandler(
                                suggestion.skuName,
                                suggestion.skuCode
                              )
                            }
                            style={{
                              paddingBottom:
                                suggestions.length - 1 != i && "10px",
                              borderBottom:
                                suggestions.length - 1 != i &&
                                "1px solid #f4f4f4",
                            }}
                          >
                            <div className={styles["search_image"]}>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M15.9499 14.7568L19.608 18.4149C19.7496 18.5565 19.7496 18.7855 19.608 18.9271L18.927 19.6081C18.7854 19.7497 18.5564 19.7497 18.4148 19.6081L14.7567 15.95C14.6904 15.8807 14.6512 15.7903 14.6512 15.6939V15.2962C13.5514 16.2453 12.1201 16.8209 10.5532 16.8209C7.09098 16.8209 4.28564 14.0155 4.28564 10.5533C4.28564 7.0911 7.09098 4.28577 10.5532 4.28577C14.0154 4.28577 16.8207 7.0911 16.8207 10.5533C16.8207 12.1202 16.2452 13.5515 15.296 14.6513H15.6938C15.7902 14.6513 15.8806 14.6875 15.9499 14.7568ZM5.732 10.5533C5.732 13.217 7.88949 15.3745 10.5532 15.3745C13.2169 15.3745 15.3744 13.217 15.3744 10.5533C15.3744 7.88961 13.2169 5.73212 10.5532 5.73212C7.88949 5.73212 5.732 7.88961 5.732 10.5533Z"
                                  fill="#949494"
                                />
                              </svg>
                            </div>

                            <div className={styles["recommendation_content"]}>
                              <span className={styles["brand_name"]}>
                                {suggestion ? suggestion.brandName : ""}
                              </span>
                              {suggestion ? (
                                <div className={styles["content"]}>
                                  {splitSuggestion(suggestion.skuCode)}{" "}
                                  {splitSuggestion(suggestion.skuName)}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ))}
                        <div className={styles["space_div_0"]}></div>
                      </>
                    ) : (
                      !isDropdownHidden &&
                      !showNoResultTemp && <SuggestionNotFoundContent />
                    )
                  ) : (
                    !isDropdownHidden &&
                    !showNoResultTemp && <SuggestionNotFoundContent />
                  )}
                </div>
                <div className={styles.close_btn} onClick={onCloseSearch}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.3473 11.9752L19.7165 6.60598C20.027 6.29545 20.027 5.79153 19.7165 5.4805L18.4689 4.2329C18.1584 3.92237 17.6545 3.92237 17.3434 4.2329L11.9747 9.60262L6.60548 4.2334C6.29495 3.92287 5.79103 3.92287 5.48 4.2334L4.2329 5.4805C3.92237 5.79103 3.92237 6.29495 4.2329 6.60598L9.60212 11.9752L4.2329 17.3444C3.92237 17.655 3.92237 18.1589 4.2329 18.4699L5.4805 19.7175C5.79103 20.028 6.29495 20.028 6.60598 19.7175L11.9747 14.3478L17.3439 19.717C17.6545 20.0275 18.1584 20.0275 18.4694 19.717L19.717 18.4694C20.0275 18.1589 20.0275 17.655 19.717 17.3439L14.3473 11.9752Z"
                      fill="#2C2C2C"
                    />
                  </svg>
                </div>
              </div>
              {showNoResultTemp && (
                <>
                  <div className={styles["not-found-div"]}>
                    <div className={styles["not-found-upper-div"]}>
                      <div className={styles["not-found-icon"]}>
                        {NotFoundIcon.icon}
                      </div>
                      <span className={styles["not-found-text"]}>
                        {/* 未搜尋到 "{notFoundText}" 相關商品 */}
                        未搜尋到 &quot;{decodeURIComponent(notFoundText)}&quot;
                        相關商品
                      </span>
                    </div>
                    <div className={styles["not-found-lower-div-text"]}>
                      請確認輸入的文字是否有誤，請嘗試重新搜尋
                    </div>
                  </div>
                  <div className={styles["not_found_space_div"]}></div>
                  <div className={styles["not_found_search_hotTopics"]}>
                    <HotTopics />
                  </div>
                  <div
                    className={styles["search_not_found_recommended_products"]}
                  >
                    <RecommendedProducts
                      sceneType={"NO_SEARCH"}
                      relateCode={""}
                      heading={"其他人都在搜尋"}
                      backgroundColor={"#FAFAFA"}
                      onAddToCart={addToCart}
                    />

                    <StatusPopup
                      showModal={showStatusModal}
                      setShowModal={setShowStatusModal}
                      product={details}
                    />

                    {productDetails &&
                      (breakpoint === "lg" ? (
                        <VariantDrawerDesktop
                          open={openVariantDrawer}
                          onClose={() => setOpenVariantDrawer(false)}
                          productInfo={productDetails.info}
                          renderVariants={renderVariants}
                          renderFooter={renderDrawerFooter}
                          renderAdditionalInfo={
                            productDetails.info?.isSOP && renderDeliveryInfo
                          }
                          // productStatus={getProductStatus(
                          //   productDetails?.info?.productStatus
                          // )}
                          productStatus={details.productStatus}
                        />
                      ) : (
                        <VariantDrawerMobile
                          open={openVariantDrawer}
                          setOpen={setOpenVariantDrawer}
                          productInfo={productDetails.info}
                          renderVariants={renderVariants}
                          renderFooter={renderDrawerFooter}
                          renderAdditionalInfo={
                            productDetails?.info?.isSOP && renderDeliveryInfo
                          }
                          productStatus={details.productStatus}
                          variantSelector={true}
                        />
                      ))}
                  </div>
                </>
              )}

              {isDropdownHidden && !showNoResultTemp && (
                <div className={styles["containers"]}>
                  <HotTopics />

                  {histories && histories.length > 0 && (
                    <>
                      <div className={styles["recently_explored_container"]}>
                        <div className={styles["recently_explored_head_bar"]}>
                          <span className={styles["recently_explored_text"]}>
                            最近探索
                          </span>
                          <div className={styles["right_div"]}>
                            <div
                              className={styles["remove_div"]}
                              onClick={removeAllHandler}
                            >
                              <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.2504 14.4286C10.9448 14.4285 11.5435 13.866 11.5869 13.173L12.1784 3.71428H12.6249C12.8713 3.71428 13.0713 3.51428 13.0713 3.26785V2.82142C13.0713 2.57499 12.8713 2.37499 12.6249 2.37499H10.3257L9.37708 0.792955C9.16172 0.434101 8.64725 0.142849 8.22872 0.142849H5.41386C4.99533 0.142849 4.48086 0.434101 4.2655 0.792955L3.31684 2.37499H1.01772C0.771288 2.37499 0.571289 2.57499 0.571289 2.82142V3.26785C0.571289 3.51428 0.771288 3.71428 1.01772 3.71428H1.46415L2.05567 13.173C2.09905 13.866 2.69782 14.4285 3.39215 14.4286H10.2504ZM8.76324 2.37499H4.87934L5.41503 1.48213H8.22755L8.76324 2.37499ZM3.39245 13.0893H10.2504L10.8366 3.71428H2.80651L3.39245 13.0893Z"
                                  fill="#2C2C2C"
                                />
                              </svg>
                              <span className={styles["remove_text"]}>
                                清空紀錄
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className={styles["recently_explored_items"]}>
                          {histories &&
                            histories.map((item, index) => {
                              return (
                                <div
                                  className={styles["item_div"]}
                                  style={{
                                    borderBottom:
                                      index != histories.length - 1 &&
                                      "1px dashed #E4E4E4",
                                  }}
                                >
                                  <div
                                    className={styles["search_img"]}
                                    onClick={selectRecentSearch(item)}
                                  >
                                    <svg
                                      width="24"
                                      height="25"
                                      viewBox="0 0 24 25"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M15.9499 15.0424L19.608 18.7005C19.7496 18.8421 19.7496 19.0712 19.608 19.2128L18.927 19.8938C18.7854 20.0354 18.5564 20.0354 18.4148 19.8938L14.7567 16.2357C14.6904 16.1664 14.6512 16.076 14.6512 15.9796V15.5818C13.5514 16.531 12.1201 17.1065 10.5532 17.1065C7.09098 17.1065 4.28564 14.3012 4.28564 10.839C4.28564 7.37674 7.09098 4.57141 10.5532 4.57141C14.0154 4.57141 16.8207 7.37674 16.8207 10.839C16.8207 12.4059 16.2452 13.8371 15.296 14.937H15.6938C15.7902 14.937 15.8806 14.9731 15.9499 15.0424ZM5.732 10.839C5.732 13.5027 7.88949 15.6602 10.5532 15.6602C13.2169 15.6602 15.3744 13.5027 15.3744 10.839C15.3744 8.17525 13.2169 6.01777 10.5532 6.01777C7.88949 6.01777 5.732 8.17525 5.732 10.839Z"
                                        fill="#949494"
                                      />
                                    </svg>
                                  </div>

                                  <div
                                    className={
                                      styles["frequently_searched_text"]
                                    }
                                    onClick={selectRecentSearch(item)}
                                  >
                                    {item}
                                  </div>

                                  <div
                                    className={styles["clear_img"]}
                                    onClick={clearSearchHandler(item)}
                                  >
                                    <svg
                                      width="8"
                                      height="9"
                                      viewBox="0 0 8 9"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.29283 8.0368L7.79302 7.5366C8.06921 7.26041 8.06921 6.81264 7.79302 6.53624L5.54239 4.2856L7.79302 2.03497C8.06921 1.75881 8.06921 1.31102 7.79302 1.03461L7.29283 0.534413C7.01664 0.258223 6.56887 0.258223 6.29246 0.534413L4.04183 2.78504L1.7912 0.534413C1.51503 0.258223 1.06724 0.258223 0.790832 0.534413L0.290638 1.03461C0.0144487 1.3108 0.0144487 1.75856 0.290638 2.03497L2.54127 4.2856L0.290638 6.53624C0.0144487 6.8124 0.0144487 7.26019 0.290638 7.5366L0.790832 8.0368C1.06702 8.31298 1.51503 8.31298 1.7912 8.0368L4.04183 5.78616L6.29246 8.0368C6.56863 8.31298 7.01664 8.31298 7.29283 8.0368Z"
                                        fill="#949494"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </>
                  )}
                  {histories && histories.length > 0 && (
                    <div className={styles["space_div_2"]}></div>
                  )}
                </div>
              )}
            </div>
            {/* Search code ends */}
          </div>
        </div>
        {/* <MobileSearchBar
          placeHolderData={placeHolderData}
          onCloseSearchTab={onCloseSearchTab}
          show={showSearchBar}
        /> */}
        {scrollY && (breakpoint == 'xs' || breakpoint == 'sm') && loggedInUserData?.role === "ABO" && (currPath == '/' || currPath == ' ') && (
          <div className={`${styles.switchRecipient_bar}`}>
            <SwitchRecipient
              variants="buyer"
              text="目前訂貨人"
              breakpoint={breakpoint}
              router={history}
              onClick={ControllScroll}
            />
          </div>
        )}
      </div>
      <div className={styles.header_login}>
        {isDesktop && username !== "" && loggedInUserData.role === "ABO" ? (
          <div className={styles.login_switch}>
            <div className={styles.login_user}>
              <div className={styles.login_left}>
                <div className={styles.login_payer}>
                  <span>付款人:</span>
                  <span>{mainName}</span>
                </div>
                <div className={styles.login_out}>
                  夥伴您好 ！<em onClick={handleLogout}>登出</em>
                </div>
              </div>
              <div className={styles.login_right}>
                {username && (
                  <SwitchRecipient
                    variants="buyer"
                    breakpoint={breakpoint}
                    text="目前訂貨人"
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        className={styles.header_lg}
        ref={headerDesktopRef}
        style={showShadow ? { boxShadow: lgHeaderShadow } : undefined}
      >
        <div className={styles.navigation_bar} onClick={closeModal}>
          <div className={styles.left_section}>
            <div className={styles.logo_area}>
              <a href={homePagePath}>
                <Icon name="amway_logo" />
              </a>
            </div>
            <div className={styles.nav_area} id="navArea">
              {navTabs.map((tab, index) => {
                return (
                  <div
                    className={styles.dropdown_area}
                    key={`dropdown_area${index}`}
                    id="dropdownArea"
                    onMouseOver={closeModal}
                  >
                    <Button
                      className={styles.btn_name}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onMouseEnter={() => handleSelectNavigation(tab.code)}
                    >
                      <span className={styles.nav_link_text}>{tab.name}</span>
                      <DropDownIcon />
                    </Button>

                    {selectedNav === tab.code &&
                      navigationMenus.length > 0 &&
                      navigationMenus.filter((item) => item.type === tab.code)
                        .length > 0 && (
                        <Navigation
                          Link={Link}
                          type={selectedNav}
                          // onClick={hamburgerClickHandler}
                          exStyles={{
                            top:
                              username && loggedInUserData.role === "ABO"
                                ? 50
                                : document.getElementById("navArea") &&
                                  document.getElementById("dropdownArea")
                                  ? document.getElementById("navArea")
                                    .offsetHeight -
                                  document.getElementById("dropdownArea")
                                    .offsetTop
                                  : 0,
                          }}
                          navDomHeight={navDomHeight}
                          navigationMenus={
                            navigationMenus.filter(
                              (item) => item.type === tab.code
                            )[0].subCategories
                          }
                          callback={() => handleSelectNavigation("")}
                        />
                      )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.right_section}>
            <div className={styles.search_area} ref={desktopSearchRef}>
              <form action="" onSubmit={onSearch} autoComplete="off">
                <div className={styles.form_control}>
                  <input
                    id="inputSearchDesktop"
                    className={styles.form_input}
                    type="search"
                    autoComplete="off"
                    placeholder={placeHolderData ? placeHolderData : "搜索產品"}
                    onClick={openModal}
                    value={text}
                    onChange={(e) => onChangeOfSearchInput(e.target.value)}
                    onFocus={() =>
                      handleCancelBtn(input_search, setCrossIconStyles)
                    }
                  />
                  <div className={styles.search_icon}>
                    <SearchIconGray />
                  </div>
                  {loading ? (
                    <div className={styles["show_indicator"]}>
                      <Spinner />
                    </div>
                  ) : null}
                  <span
                    onClick={onCrossIconClick}
                    className={styles["cancel-btn"]}
                    style={crossIconStyles}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9561 9.97925L16.4305 5.5049C16.6892 5.24613 16.6892 4.82619 16.4305 4.567L15.3908 3.52733C15.132 3.26856 14.7121 3.26856 14.4529 3.52733L9.97896 8.0021L5.50461 3.52775C5.24584 3.26897 4.8259 3.26897 4.56671 3.52775L3.52746 4.567C3.26868 4.82578 3.26868 5.24571 3.52746 5.5049L8.00181 9.97925L3.52746 14.4536C3.26868 14.7124 3.26868 15.1323 3.52746 15.3915L4.56712 16.4312C4.8259 16.6899 5.24584 16.6899 5.50503 16.4312L9.97896 11.9564L14.4533 16.4308C14.7121 16.6895 15.132 16.6895 15.3912 16.4308L16.4309 15.3911C16.6897 15.1323 16.6897 14.7124 16.4309 14.4532L11.9561 9.97925Z"
                        fill="#2C2C2C"
                      />
                    </svg>
                  </span>
                </div>
              </form>
            </div>

            <div className={styles.dropdown_area} onMouseOver={closeModal}>
              <Button
                className={styles.btn_name}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={toggleSignInDropdown}
              >
                <span className={styles.icon_container}>
                  <Icon name={"user_icon"} />
                </span>
                <span className={styles.user_name} title={profileName}>{profileName}</span>
                <DropDownIcon />
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={signInAnchorEl}
                keepMounted
                open={Boolean(signInAnchorEl)}
              >
                <MenuItem>
                  <a>{"signInOptions"}</a>
                </MenuItem>
              </Menu>
            </div>
            <div className={styles.icon_container} onClick={onCartClick}>
              <Icon name={"shopping_cart"} />
              {cartItemCount === 0 ? null : (
                <div className={styles["cart_count"]}>
                  {viewCount(cartItemCount)}
                </div>
              )}
            </div>
          </div>
        </div>

        <SearchModal
          showModal={showModal}
          setShowModal={setShowModal}
          text={text}
          setText={setText}
          suggestions={suggestions}
          setSuggestions={setSuggestions}
          isDropdownHidden={isDropdownHidden}
          setIsDropdownHidden={setIsDropdownHidden}
          histories={histories}
          setHistory={setHistory}
          hotTopics={hotTopics}
          setHotTopics={setHotTopics}
          foundElementSkuCode={foundElementSkuCode}
          setFoundElementSkuCode={setFoundElementSkuCode}
          loading={loading}
          onChangeHandler={onChangeHandler}
          headerDesktopRef={headerDesktopRef}
          desktopSearchRef={desktopSearchRef}
          actualSuggestionCount={actualSuggestionCount}
        ></SearchModal>
      </div>
      {/* )} */}
      <SwipeableDrawer
        anchor={"left"}
        open={showProfileMenu}
        disableDiscovery={false}
        disableSwipeToOpen={true}
        onClose={() => setShowProfileMenu(false)}
        onOpen={() => console.log('Drawer is opening')}
      >
        <CIMenuPanel
          showMenu={true}
          Link={Link}
          breakpoint={breakpoint}
          callback={showProfileMobileMenuLink}
        />
      </SwipeableDrawer>
      <PopupConfirm
        title="登出"
        showPopup={showLogout}
        okBtn={{
          text: "登出",
          action: handleActionLogout,
        }}
        cancelBtn={{
          text: "取消",
          action: handleActionCancel,
        }}
      >
        <span>您確定要退出嗎</span>
      </PopupConfirm>

      <MiniCart
        headerData={headerData}
        headerRef={isDesktop ? headerDesktopRef : headerMobileRef}
      />
    </div>
  );
};

export default Header;
